import { useCallback, useEffect, useState } from 'react';
import { isLarge, isXLarge, isXXLarge } from 'src/common/utils/breakpoints';

export default function useSideBar(
  breakpoint,
  isMobile,
  { isLanding, hideRightSideTillXxl, matchUrl },
) {
  const isNotLandingOrMobile = !(isLanding || isMobile);
  const isLeftSideDocked = isNotLandingOrMobile && isLarge(breakpoint);
  // Right side serves on xxlarge profile pages and xlarge other pages (not on landing page)
  const isRightSideOpen =
    isNotLandingOrMobile &&
    (hideRightSideTillXxl ? isXXLarge(breakpoint) : isXLarge(breakpoint));
  const [isLeftSideOpen, setIsLeftSideOpen] = useState(isLeftSideDocked);

  useEffect(() => {
    setIsLeftSideOpen(isLeftSideDocked);
  }, [matchUrl, isLeftSideDocked]);

  const handleLeftSideToggle = useCallback(() => {
    setIsLeftSideOpen((value) => !value);
  }, []);

  return {
    isLeftSideDocked,
    isLeftSideOpen,
    isRightSideOpen,
    handleLeftSideToggle,
  };
}
